export var StorePOSProviderEnum;
(function (StorePOSProviderEnum) {
    StorePOSProviderEnum["TOAST"] = "toast";
    StorePOSProviderEnum["SQUARE"] = "square";
    StorePOSProviderEnum["CHOWLY"] = "chowly";
    StorePOSProviderEnum["GOPARROT"] = "goparrot";
})(StorePOSProviderEnum || (StorePOSProviderEnum = {}));
//# sourceMappingURL=store-pos-provider.enum.js.map